import styled from "styled-components";

export const TBody = styled.tbody`
  flex: 1;
  position: relative;
`;

export default TBody;
